import {
  Box,
  Divider,
  CircularProgress,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings';
import { SearchBar } from './SearchBar';
import { CreateMenu } from './CreateMenu';
import { UserMenu } from './UserMenu';
import { useUserIdentity } from './useUserIdentity';
import { useRoleContext } from './RoleContext';
import { AiSparkleIcon } from '../Root/AiSparkleIcon';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'sticky',
    top: 0,
    zIndex: theme.zIndex.appBar,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    height: 56,
    gap: 16,
    paddingLeft: 24,
    paddingRight: 24,
  },
  spacer: {
    flex: 1,
  },
  divider: {
    height: 28,
    alignSelf: 'center',
  },
  headerIcon: {
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
  copilotIcon: {
    color: '#7C3AED',
    '&:hover': {
      color: '#6D28D9',
    },
  },
}));

export function GlobalHeader() {
  const classes = useStyles();
  const { identity, loading: identityLoading } = useUserIdentity();
  const { activeRole, setActiveRole, loading: roleLoading } = useRoleContext();
  const loading = identityLoading || roleLoading;

  return (
    <Box className={classes.root}>
      <SearchBar />
      <Box className={classes.spacer} />
      <CreateMenu />
      <Tooltip title="AI Agent">
        <IconButton
          className={classes.copilotIcon}
          size="small"
          href="/ai-agent"
        >
          <AiSparkleIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Settings">
        <IconButton
          className={classes.headerIcon}
          size="small"
          href="/settings"
        >
          <SettingsIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Divider orientation="vertical" flexItem className={classes.divider} />
      {loading || !identity || !activeRole ? (
        <CircularProgress size={24} />
      ) : (
        <UserMenu
          identity={identity}
          activeRole={activeRole}
          setActiveRole={setActiveRole}
        />
      )}
    </Box>
  );
}
